import WebRoutes from "./routes";

function App() {
  return (
    <>
      <WebRoutes />
    </>
  );
}

export default App;
